<div [ngClass]="currentPage.path === 'developer' ? 'contact-wrapper-big' : 'contact-wrapper'">
  <div class="content-description">
    <h2>Contact Me</h2>
  </div>

  <div id="contact-content">
    <div class="contact-icons">
      <p>Contact me via social media (links below) or by sending email through contact form</p>
      <div class="contact-icon">
        <a href="mailto:sami.valkonen2@gmail.com" target="_blank"><i class="fas fa-envelope"></i></a>
      </div>
      <div class="contact-icon">
        <a href="https://www.linkedin.com/in/sami-valkonen-6ba281b2/" target="_blank"
          ><i class="fab fa-linkedin-in"></i
        ></a>
      </div>
      <div class="contact-icon">
        <a href="https://gitlab.com/samiv"><i class="fab fa-gitlab" target="_blank"></i></a>
      </div>
      <div class="contact-icon">
        <a href="https://www.facebook.com/sami.valkonen.5" target="_blank"><i class="fab fa-facebook-f"></i></a>
      </div>
      <div class="contact-icon">
        <a href="https://www.instagram.com/sambyviiva/" target="_blank"><i class="fab fa-instagram"></i></a>
      </div>
    </div>
    <div id="contact-form">
      <h2 (dblclick)="showContacts()">Contact Form</h2>
      <div class="contact-form-content">
        <mat-form-field>
          <input matInput placeholder="Name" #name="ngModel" [(ngModel)]="model.name" />
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            placeholder="Email"
            #email="ngModel"
            [(ngModel)]="model.email"
          />
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Subject" #subject="ngModel" [(ngModel)]="model.subject" />
        </mat-form-field>
        <mat-form-field>
          <textarea
            matTextareaAutosize
            matAutosizeMinRows="5"
            matInput
            placeholder="Message..."
            #message="ngModel"
            [(ngModel)]="model.message"
          ></textarea>
        </mat-form-field>
        <button mat-raised-button class="submit-button" color="warn" (click)="onSubmitMail()">Send</button>
        <!-- <button mat-raised-button (click)="">Test</button> -->
        <span *ngIf='infoMessage !== null' class="info-message"> {{ infoMessage }}</span>
        <span *ngIf='errorMessage !== null' class="error-message"> {{ errorMessage }}</span>
      </div>
    </div>
  </div>
</div>
